module.exports = __webpack_public_path__ + "media/images/icon__info--rb-gray@2x-9d168412649f5b578ef9f723476fe93b.png";